;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { Icon, IconName } from '@qogita/ui/v2/icon'
import { LayeredStack } from '@qogita/ui/v2/layered-stack'
import {
  Navigation,
  NavigationItem,
  NavigationSection,
  NavigationSectionHeading,
  NavigationSectionItems,
} from '@qogita/ui/v2/navigation'
import Link from 'next/link'
import { useUserContext } from 'src/deprecated/contexts/User'
import { useIsPotentialSuppliersActingOnBuyerRequestsEnabled } from 'src/deprecated/hooks/featureFlags'
import { routes } from 'src/deprecated/utils/routes'

type SellerSidebarProps = {
  validateIsActiveLink: (testPath: RegExp) => boolean
  onClickRoute?: () => void
}

export function SellerSidebar({
  validateIsActiveLink,
  onClickRoute,
}: SellerSidebarProps) {
  const user = useUserContext()

  const showInternalNavigationItems = Boolean(user?.isQogitaUser)
  const isCustomRequestsEnabled =
    useIsPotentialSuppliersActingOnBuyerRequestsEnabled()

  return (
    <Navigation>
      <SidebarNavigationItem
        as={Link}
        href="/dashboard"
        isActive={validateIsActiveLink(/\/dashboard\//)}
        onClick={onClickRoute}
      >
        <SidebarNavigationIcon
          activeIcon="heroicons/solid/home"
          inactiveIcon="heroicons/outline/home"
        />
        Dashboard
      </SidebarNavigationItem>

      <SidebarNavigationItem
        as={Link}
        href={routes.orders({ status: 'CURRENT', page: 1 })}
        isActive={validateIsActiveLink(/\/orders\//)}
        onClick={onClickRoute}
      >
        <SidebarNavigationIcon
          activeIcon="heroicons/solid/archive-box"
          inactiveIcon="heroicons/outline/archive-box"
        />
        Orders
      </SidebarNavigationItem>

      <SidebarNavigationItem
        as={Link}
        href="/price-lists"
        isActive={validateIsActiveLink(/\/price-lists\//)}
        onClick={onClickRoute}
      >
        <SidebarNavigationIcon
          activeIcon="heroicons/solid/rectangle-stack"
          inactiveIcon="heroicons/outline/rectangle-stack"
        />
        Price lists
      </SidebarNavigationItem>

      {isCustomRequestsEnabled ? (
        <SidebarNavigationItem
          as={Link}
          href="/special-offer-requests"
          isActive={validateIsActiveLink(/\/special-offer-requests\//)}
          onClick={onClickRoute}
        >
          <SidebarNavigationIcon
            activeIcon="heroicons/solid/tag"
            inactiveIcon="heroicons/outline/tag"
          />
          Custom requests
        </SidebarNavigationItem>
      ) : null}

      <SidebarNavigationItem
        as={Link}
        href={routes.inventory({ page: 1 })}
        isActive={validateIsActiveLink(/\/inventory\//)}
        onClick={onClickRoute}
      >
        <SidebarNavigationIcon
          activeIcon="heroicons/solid/clipboard-document-check"
          inactiveIcon="heroicons/outline/clipboard-document-check"
        />
        Inventory
      </SidebarNavigationItem>
      <SidebarNavigationItem
        as={Link}
        href={routes.claims({ page: 1 })}
        isActive={validateIsActiveLink(/\/claims\//)}
        onClick={onClickRoute}
      >
        <SidebarNavigationIcon
          activeIcon="heroicons/solid/document-text"
          inactiveIcon="heroicons/outline/document-text"
        />
        Claims
      </SidebarNavigationItem>

      <SidebarNavigationItem
        as={Link}
        href={routes.insights}
        isActive={validateIsActiveLink(/(\/insights\/)/)}
        onClick={onClickRoute}
      >
        <SidebarNavigationIcon
          activeIcon="heroicons/solid/presentation-chart-bar"
          inactiveIcon="heroicons/outline/presentation-chart-bar"
        />
        Insights
      </SidebarNavigationItem>

      {showInternalNavigationItems ? (
        <NavigationSection
          isActive={validateIsActiveLink(
            /(\/internal\/|\/seller-initial-checker\/)/,
          )}
        >
          {/* oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component */}
          <NavigationSectionHeading className="gap-3 group-hover:bg-gray-50 focus-visible:bg-gray-50">
            <SidebarNavigationIcon
              activeIcon="heroicons/solid/chart-bar"
              inactiveIcon="heroicons/outline/chart-bar"
            />
            Internal
          </NavigationSectionHeading>

          <NavigationSectionItems>
            <SidebarNavigationItem
              as={Link}
              href="/internal/seller-initial-checker"
              isActive={validateIsActiveLink(
                /^\/internal\/seller-initial-checker/,
              )}
              onClick={onClickRoute}
            >
              Seller GTIN checker
            </SidebarNavigationItem>

            <SidebarNavigationItem
              as={Link}
              href="/internal/seller-onboarding"
              onClick={onClickRoute}
              isActive={validateIsActiveLink(/^\/internal\/seller-onboarding/)}
            >
              Seller onboarding
            </SidebarNavigationItem>
          </NavigationSectionItems>
        </NavigationSection>
      ) : null}

      <SidebarNavigationItem
        as={Link}
        href="/integrations"
        isActive={validateIsActiveLink(/\/integrations\//)}
        onClick={onClickRoute}
      >
        <SidebarNavigationIcon
          activeIcon="heroicons/solid/server-stack"
          inactiveIcon="heroicons/outline/server-stack"
        />
        Integrations
      </SidebarNavigationItem>

      <SidebarNavigationItem
        as={Link}
        href="/help-center"
        isActive={validateIsActiveLink(/\/help-center\//)}
        onClick={onClickRoute}
      >
        <SidebarNavigationIcon
          activeIcon="heroicons/solid/question-mark-circle"
          inactiveIcon="heroicons/outline/question-mark-circle"
        />
        Help center
      </SidebarNavigationItem>
    </Navigation>
  )
}

function SidebarNavigationItem({
  ...props
}: React.ComponentProps<typeof NavigationItem>) {
  return (
    <NavigationItem
      {...props}
      // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
      className="gap-3 text-gray-900 group-hover:bg-gray-50 focus-visible:bg-gray-50"
    />
  )
}

function SidebarNavigationIcon({
  activeIcon,
  inactiveIcon,
}: {
  activeIcon: IconName
  inactiveIcon: IconName
}) {
  return (
    <LayeredStack>
      <Icon
        name={inactiveIcon}
        // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
        className='size-4.5 opacity-100 group-has-aria-[current="page"]:opacity-0'
      />
      <Icon
        name={activeIcon}
        // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
        className='size-4.5 opacity-0 group-has-aria-[current="page"]:opacity-100'
      />
    </LayeredStack>
  )
}
